import { HTMLAttributes, memo } from 'react';
import { css, SerializedStyles } from '@emotion/react';
import { DemoChip } from '@frontend/analytics-shared';
import { Chart, ChartSneakPeakDataItem } from '@frontend/charts';
import { theme } from '@frontend/theme';
import { ContentLoader } from '@frontend/design-system';

interface Props extends HTMLAttributes<HTMLDivElement> {
  data: ChartSneakPeakDataItem[];
  isDemoAccount?: boolean;
  isLoading?: boolean;
  wrapperStyles?: SerializedStyles;
}

export const InlineStats = memo(({ data, isDemoAccount, isLoading, wrapperStyles, ...rest }: Props) => {
  return (
    <section css={[styles.wrapper, wrapperStyles]} {...rest}>
      {isDemoAccount && <DemoChip />}
      <Chart.SneakPeakBar data={data} />
      <ContentLoader show={isLoading} size='small' />
    </section>
  );
});

InlineStats.displayName = 'InlineStats';

const styles = {
  wrapper: css`
    border-radius: ${theme.borderRadius.medium};
    border: 1px solid ${theme.colors.neutral20};
    isolation: isolate;
    margin-bottom: ${theme.spacing(3)};
    overflow: hidden;
    padding: ${theme.spacing(3)};
    position: relative;
    z-index: 3;
  `,
};
